// @ts-nocheck
import * as constants from './constants';

export const createActionName = (eventName: string) => {
  return `group-data-action/${eventName}`;
};
